import {defineMessages} from 'react-intl'

export const filterMessages = defineMessages({
  // Filters
  filters: {
    id: 'filters',
    defaultMessage: 'Filters'
  },
  // Selected filters
  selectedFilters: {
    id: 'selectedFilters',
    defaultMessage: 'Selected filters'
  },
  // All filters
  allFilters: {
    id: 'filters.all',
    defaultMessage: 'All filters'
  },
  // Free cancellation
  freeCancellationTitle: {
    id: 'cancellationPenalties.freeCancellation',
    defaultMessage: 'Free cancellation'
  },
  freeCancellationSubtitle: {
    id: 'filters.freeCancellationSubtitle',
    defaultMessage: 'Show deals with free cancellation'
  },
  // Popular
  popular: {
    id: 'popularFilters',
    defaultMessage: 'Popular filters'
  },
  // Star rating
  hotelStarClass: {
    id: 'filters.hotelStarClass',
    defaultMessage: 'Hotel star class'
  },
  // Price
  priceFilter: {
    id: 'priceFilter',
    defaultMessage: 'Price'
  },
  // Review
  reviewScore: {
    id: 'filters.reviewScore',
    defaultMessage: 'Review score'
  },
  // Facilities
  amenities: {
    id: 'amenities',
    defaultMessage: 'Amenities'
  },

  facilitiesExpanded: {
    id: 'showLess',
    defaultMessage: 'Show less'
  },
  // Traveler experience
  travelerExperience: {
    id: 'travelerExperience',
    defaultMessage: 'Traveler experience'
  },
  // Property type
  propertyType: {
    id: 'propertyType',
    defaultMessage: 'Property type'
  },
  propertyTypeContracted: {
    id: 'filters.propertyTypeContracted',
    defaultMessage: 'See all property types'
  },
  // Common
  noFiltersAvailable: {
    id: 'noFiltersAvailable',
    defaultMessage: 'No filters available for your search'
  },
  allTypes: {
    id: 'allPropertyTypes',
    defaultMessage: 'All'
  },
  popularTypes: {
    id: 'popularPropertyTypes',
    defaultMessage: 'popular'
  },
  hotelsTypes: {
    id: 'propertyType.hotelsTitle',
    defaultMessage: 'Hotels'
  },
  vacationRentalsTypes: {
    id: 'propertyType.vacationRentalsTitle',
    defaultMessage: 'Vacation rentals'
  },
  applyFilters: {
    id: 'filters.applyPlural',
    defaultMessage: 'Apply {count, plural, one {1 filter} other {# filters}}'
  },
  // Show less
  showLess: {
    id: 'showLess',
    defaultMessage: 'Show less'
  },
  // Show more
  showMore: {
    id: 'showMore',
    defaultMessage: 'Show more'
  },
  // Meal Plans
  mealPlans: {
    id: 'filters.mealPlans',
    defaultMessage: 'Meal plans'
  },
  breakfast: {
    id: 'mealType.breakfastIncluded',
    defaultMessage: 'Breakfast included'
  },
  allInclusive: {
    id: 'mealType.allInclusive',
    defaultMessage: 'All inclusive'
  },
  payLater: {
    id: 'paymentSchedule.payLater',
    defaultMessage: 'Pay later'
  },
  bookingOptions: {
    id: 'bookingOptions',
    defaultMessage: 'Booking options'
  },
  // Property brand
  propertyBrand: {
    id: 'filters.propertyBrand',
    defaultMessage: 'Property brand'
  },
  // Neighborhood
  neighborhood: {
    id: 'filters.neighborhood',
    defaultMessage: 'Neighborhood'
  },
  // Recently used filters
  recentlyUsed: {
    id: 'recentlyUsed',
    defaultMessage: 'Recently used'
  },
  selected: {
    id: 'selected',
    defaultMessage: 'Selected'
  },
  onlyOnVio: {
    id: 'vioLabelFinal',
    defaultMessage: 'Only on Vio'
  },
  // Deal freeze
  // Added as a part of c747927f-deal-freeze-srp
  freezeDeal: {
    id: 'dealFreeze.freezeDeal',
    defaultMessage: 'Freeze deal'
  },
  freezable: {
    id: 'dealFreeze.freezable',
    defaultMessage: 'Freezable'
  }
})
